import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Login thunk with Flask credentials support
export const loginUser = (user, history) => async (dispatch) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });

    const data = await response.json();

    // Log error details if login fails
    if (!response.ok) {
      console.error('Login failed:', data);
      console.error('Status:', response.status);
      throw new Error(data.error || "Login failed");
    }

    // Store authentication data
    sessionStorage.setItem("authUser", JSON.stringify(data));
    
    // Store Flask credentials if provided
    if (data.flaskConfig) {
      localStorage.setItem('flaskApiUrl', data.flaskConfig.apiUrl);
      localStorage.setItem('flaskApiKey', data.flaskConfig.apiKey);
      console.log('Flask credentials stored:', {
        url: data.flaskConfig.apiUrl,
        hasKey: !!data.flaskConfig.apiKey
      });
    } else {
      console.warn('No Flask configuration provided in login response');
      // Use environment variables as fallback
      localStorage.setItem('flaskApiUrl', process.env.REACT_APP_FLASK_API_URL || '');
      localStorage.setItem('flaskApiKey', process.env.REACT_APP_API_KEY || '');
    }

    dispatch(loginSuccess(data));
    history("/dashboard");
  } catch (error) {
    console.error('Login error:', error);
    dispatch(apiError(error.message || "Something went wrong"));
  }
};

// Logout thunk - log to server then clear all stored credentials
export const logoutUser = () => async (dispatch) => {
  try {
    // Notify backend to record logout event (best-effort)
    const authUser = sessionStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      const token = parsed?.token;
      if (token) {
        fetch(`${API_BASE_URL}/auth/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        }).catch(() => {});
      }
    }

    // Clear session storage
    sessionStorage.removeItem("authUser");

    // Clear Flask credentials from local storage
    localStorage.removeItem('flaskApiUrl');
    localStorage.removeItem('flaskApiKey');

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    console.error('Logout error:', error);
    dispatch(apiError(error));
  }
};

// Social login (still mocked, but with Flask credentials handling)
export const socialLogin = (type, history) => async (dispatch) => {
  try {
    const response = {
      email: "socialuser@example.com",
      name: "Social User",
      token: "social-token-123",
      // Mock Flask config for social login
      flaskConfig: {
        apiUrl: process.env.REACT_APP_FLASK_API_URL,
        apiKey: process.env.REACT_APP_API_KEY
      }
    };
    
    sessionStorage.setItem("authUser", JSON.stringify(response));
    
    // Store Flask credentials
    if (response.flaskConfig) {
      localStorage.setItem('flaskApiUrl', response.flaskConfig.apiUrl);
      localStorage.setItem('flaskApiKey', response.flaskConfig.apiKey);
    }
    
    dispatch(loginSuccess(response));
    history("/dashboard");
  } catch (error) {
    console.error('Social login error:', error);
    dispatch(apiError(error));
  }
};

// Reset login flag
export const resetLoginFlag = () => async (dispatch) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error));
  }
};

// Helper function to get Flask credentials (optional utility)
export const getFlaskCredentials = () => {
  return {
    apiUrl: localStorage.getItem('flaskApiUrl') || process.env.REACT_APP_FLASK_API_URL,
    apiKey: localStorage.getItem('flaskApiKey') || process.env.REACT_APP_API_KEY
  };
};

// Helper function to check if Flask credentials are configured
export const hasFlaskCredentials = () => {
  const url = localStorage.getItem('flaskApiUrl');
  const key = localStorage.getItem('flaskApiKey');
  return !!(url && key);
};